import { useContext } from 'react';

import { ScenarioDetailsContext } from '../context/ScenarioDetailsContext';

export const useScenarioDetailsContext = () => {
  const context = useContext(ScenarioDetailsContext);

  if (!context)
    throw new Error(
      'useScenarioDetailsContext needs to be used within ScenarioDetailsContext.Provider!'
    );

  return context;
};
